export default __webpack_public_path__ + "static/media/parque_cafe.4e232f0c.jpeg";